import axios from 'axios';
import { httpResponse } from './api-response-status';
import { resources } from './resources';
import apiClient, { getApiPhoto } from './setup';
import { user } from './user';

interface RequestProps {
  path: string;
  data?: object | FormData | undefined;
  headers?: object | undefined;
  params?: object | undefined;
}

const getRequest = async (
  props: RequestProps,
  response?: (data: any) => void,
  errorResponse?: (error: any) => void
) => {
  try {
    const result = await apiClient.get(props.path, {
      headers: props.headers,
      params: props.params,
    });

    if (response === undefined) {
      return httpResponse('SUCCESS', result.data);
    } else {
      response(result.data);
    }
  } catch (error) {
    if (errorResponse === undefined) {
      if (axios.isAxiosError(error)) {
        return httpResponse('ERROR', error.response?.data);
      }
    } else {
      if (axios.isAxiosError(error)) {
        errorResponse(error.response?.data);
      }
    }
  }
};

const postRequest = async (
  props: RequestProps,
  response?: (data: any) => void,
  errorResponse?: (error: any) => void
) => {
  try {
    // For FormData, let axios set the Content-Type header automatically (includes boundary)
    const isFormData = props.data instanceof FormData;
    const headers = isFormData
      ? { 'Content-Type': undefined, ...props.headers } // Explicitly unset default Content-Type
      : props.headers;

    const result = await apiClient.post(props.path, props.data, {
      headers,
      params: props.params,
    });
    if (response === undefined) {
      return httpResponse('SUCCESS', result.data);
    } else {
      response(result.data);
    }
  } catch (error) {
    if (errorResponse === undefined) {
      if (axios.isAxiosError(error)) {
        return httpResponse('ERROR', error.response?.data);
      }
    } else {
      if (axios.isAxiosError(error)) {
        errorResponse(error.response?.data);
      }
    }
  }
};

const putRequest = async (
  props: RequestProps,
  response?: (data: any) => void,
  errorResponse?: (error: any) => void
) => {
  try {
    // For FormData, let axios set the Content-Type header automatically (includes boundary)
    const isFormData = props.data instanceof FormData;
    const headers = isFormData
      ? { 'Content-Type': undefined, ...props.headers } // Explicitly unset default Content-Type
      : props.headers;

    const result = await apiClient.put(props.path, props.data, {
      headers,
      params: props.params,
    });
    if (response === undefined) {
      return httpResponse('SUCCESS', result.data);
    } else {
      response(result.data);
    }
  } catch (error) {
    if (errorResponse === undefined) {
      if (axios.isAxiosError(error)) {
        return httpResponse('ERROR', error.response?.data);
      }
    } else {
      if (axios.isAxiosError(error)) {
        errorResponse(error.response?.data);
      }
    }
  }
};

const deleteRequest = async (
  props: RequestProps,
  response?: (data: any) => void,
  errorResponse?: (error: any) => void
) => {
  try {
    const result = await apiClient.delete(props.path, {
      headers: props.headers,
      params: props.params,
    });

    if (response === undefined) {
      return httpResponse('SUCCESS', result.data);
    } else {
      response(result.data);
    }
  } catch (error) {
    if (errorResponse === undefined) {
      if (axios.isAxiosError(error)) {
        return httpResponse('ERROR', error.response?.data);
      }
    } else {
      if (axios.isAxiosError(error)) {
        errorResponse(error.response?.data);
      }
    }
  }
};

const api = {
  getApiPhoto,
  user,
  resources,
  get: getRequest,
  post: postRequest,
  delete: deleteRequest,
  put: putRequest,
};

export default api;
